// extracted by mini-css-extract-plugin
export default {"client":"ClientDetails_client__WBmBA","mainInfo":"ClientDetails_mainInfo__sxU-V","addInfo":"ClientDetails_addInfo__PdsWM","usersList":"ClientDetails_usersList__tDXrx"};